module.exports = __webpack_public_path__ + "static/media/Tristana.34244a51.png";